import React from 'react';
import PropTypes from 'prop-types';
import TableTitle from 'components/MovieTable/TableTitle';
import TableData from 'components/MovieTable/TableData';
import './movie-table.scss';

const MovieTable = ({
  timeList, realTableData, dateNowIndex, isVisible, selectedDate, onModalClick, activeModal, width, hours, minutes, brandClass,
}) => {
  const isModalActive = activeModal.title === null && activeModal.index === null ? ' scroll' : '';
  const isTableVisible = isVisible ? ' none' : '';
  return (
    <div className={`react-movie-table-container${isTableVisible}${isModalActive} full-container`}>
      <div className="react-movie-table-container-inner">
        <table className="react-movie-table">
          <thead className={`react-movie-table-head-container react-mozi-brand ${brandClass} react-active`}>
            <tr className="react-movie-table-row">
              <th className="react-movie-table-head">&nbsp;</th>
              {timeList.map(time => (<th key={time} className={`react-movie-table-head react-mozi-brand ${brandClass} react-active`}>{time}</th>))}
            </tr>
          </thead>
          <tbody className="react-movie-table-body-container">
            {
              realTableData.length
                ? realTableData.map(row => (
                  <tr className="react-movie-table-row" key={row.title}>
                    <TableTitle
                      key={row.title}
                      title={row.title}
                      agelimit={row.ageLimit}
                      dubSubCodes={row.dubSubCodes}
                      visualEffects={row.visualEffects}
                      href={row.cannonicalUrl}
                      brandClass={brandClass}
                    />
                    {row.schedule.map((schedule, index) => (
                      <TableData
                        key={index.toString()}
                        dateNowIndex={dateNowIndex}
                        rowIndex={index}
                        schedule={schedule}
                        selectedDate={selectedDate}
                        onModalClick={(modal) => { onModalClick(modal); }}
                        activeModal={activeModal}
                        title={row.title}
                        width={width}
                        hours={hours}
                        minutes={minutes}
                        brandClass={brandClass}
                      />
                    ))}
                  </tr>
                ))
                : (
                  <tr className="react-movie-table-row">
                    <td className={`react-movie-table-data react-mozi-brand ${brandClass}`} colSpan="9">
                      <div className="react-movie-table-data-container no-movie">
                        <div className="react-movie-table-data-box-title">
                          Az alábbi szűrési feltételek alapján nem található vetítés.
                        </div>
                      </div>
                    </td>
                  </tr>
                )
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

MovieTable.propTypes = {
  timeList: PropTypes.arrayOf(PropTypes.string).isRequired,
  realTableData: PropTypes.arrayOf(PropTypes.shape({})),
  isVisible: PropTypes.bool.isRequired,
  selectedDate: PropTypes.string.isRequired,
  brandClass: PropTypes.string,
  dateNowIndex: PropTypes.number,
  hours: PropTypes.number,
  minutes: PropTypes.number,
  activeModal: PropTypes.shape({}).isRequired,
  onModalClick: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
};

MovieTable.defaultProps = {
  realTableData: null,
  dateNowIndex: null,
  hours: new Date().getHours(),
  minutes: new Date().getMinutes(),
  brandClass: 'react-artmozi',
};

export default MovieTable;
